import { getRequest, postRequest } from "../http/httpRequest";

async function submitFeedback(feedback: String): Promise<String> {
  const endpoint = "/api/v1/feedbacks/submitfeedback";
  const includeBearerToken = true;
  const payload = { feedback };
  const response = await postRequest(endpoint, payload, includeBearerToken);
  const data = await response.json();
  if (!response.ok) {
    throw new Error(data.contents[0]);
  }

  return data;
}

async function getAllFeedbacks() {
  const endpoint = "/api/v1/feedbacks/getfeedback?limit=8";
  const includeBearerToken = false;
  const response = await getRequest(endpoint, includeBearerToken);
  const data = await response.json();
  return data;
}

async function fetchSellRequirements(UserLocation: {
  latitude: number;
  longitude: number;
}) {
  const endpoint = "/api/v1/feedbacks/sell-requirement";
  const includeBearerToken = true;
  const payload = {
    latitude: UserLocation.latitude,
    longitude: UserLocation.longitude,
  };
  const response = await postRequest(endpoint, payload, includeBearerToken);
  const data = await response.json();
  return data;
}

async function getUiConfigurations() {
  const endpoint = "/api/v1/configurations/get-config?configTypes=UI";
  const includeBearerToken = false;
  const response = await getRequest(endpoint, includeBearerToken);
  const data = await response.json();
  return data;
}

// announce ments api is to be created here

async function getAnnouncements() {
  const now = new Date();
  const startDate = new Date(now.getTime() - 30 * 24 * 60 * 60 * 1000).toISOString();
  const endDate = new Date(now.getTime() + 30 * 24 * 60 * 60 * 1000).toISOString();
  
  const endpoint = `/api/v1/announcements/getannouncements?startDate=${startDate}&endDate=${endDate}`;
  const includeBearerToken = true;
  const response = await getRequest(endpoint, includeBearerToken);
  const data = await response.json();
  return data;
}

export default {
  submitFeedback,
  getAllFeedbacks,
  fetchSellRequirements,
  getUiConfigurations,
  getAnnouncements,
};
